export const SET_ACTIVE_LIST = "SET_ACTIVE_LIST";
export const SET_UP_RUMBLE_STATE = "SET_UP_RUMBLE_STATE"
export const UPDATE_RUMBLE_STATE_WITH_WINNER = "UPDATE_RUMBLE_STATE_WITH_WINNER";
export const ROLLBACK_RUMBLE_STATE = "ROLLBACK_RUMBLE_STATE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";